import { BaseConfig } from '../ServiceConfig';

export const OPERATION_FLOW_CONSUMER = 'consumer';
export const OPERATION_FLOW_STAFF = 'staff';

export interface PSFirebaseConfig {
  apiKey: string;
  applicationId: string;
  databaseUrl: string;
  gcmSenderId: string;
  projectId: string;
  storageBucket: string;
}

export interface PSCallbackUrl {
  success: string;
  cancel: string;
}

export interface PSConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.PaymentServiceConfigData';
  url: string;
  bffUrl: string;
  clientCode: string;
  terminalCode: string;
  serviceCode: string;
  qrPartnerCode: string;
  cashPartnerCode: string;
  sposPartnerCode: string;
  sposMerchantCode: string;
  secret: string;
  registerSecretKey: string;
  querySecretKey: string;
  operationFlow: string;
  firebaseConfig: PSFirebaseConfig;
  callbackUrl: PSCallbackUrl;
  checkPaymentResultTimeIntervalMillis: number;
  methods: MethodConfig[];
}

export interface MethodConfig {
  name: string;
  code: string;
  config: { [key: string]: string };
}

export const PSConfigurationFields: (keyof PSConfiguration)[] = [
  'url',
  'bffUrl',
  'cashPartnerCode',
  'clientCode',
  'qrPartnerCode',
  'secret',
  'registerSecretKey',
  'querySecretKey',
  'serviceCode',
  'sposMerchantCode',
  'sposPartnerCode',
  'terminalCode',
  'operationFlow',
  'firebaseConfig',
  'callbackUrl',
  'checkPaymentResultTimeIntervalMillis',
  'methods',
];

export const BlankPSConfiguration: PSConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.PaymentServiceConfigData',
} as PSConfiguration;
